import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'mapbox-gl/dist/mapbox-gl.css';
import { PortDashboard } from './pages/portDashboard'
import { LandingPage } from './pages/landingPage'


import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/dashboard" element={<PortDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
